<template>
    <div :class="containerClassName"></div>
</template>

<script>
    import json from './json/empty-search.json';
    import _animation from './_animation.js';

    export default {
        data() {
            return {
                json: json
            }
        },
        mixins: [_animation]
    }
</script>
